export default __webpack_public_path__ + "static/media/water-tap.ee36d017.svg";